:host {
  display: block;
}

.feature-text-container {
  margin: 8px 0;
  padding: 2px;
  display: grid;
  grid-template-columns: 1fr 5fr;
}

.feature-icon {
  display: flex;
  align-content: flex-start;
  flex-direction: row;

  @include agl-ds-screen-size('medium') {
    margin-left: 10px;
  }
}

.feature-desc {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  font-size: 14px;
}
